// extracted by mini-css-extract-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1_cxi","cls2":"PostEngagementFollowPrompt-cls2_Pf2 PostEngagementFollowPrompt-cls1_cxi"};